<template>
  <div class="container household-income">
    <div class="row pt-2">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="96" :show-text="false" :stroke-width="12" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip back="ethnicity"
      skip="thankyou">
    </back-and-skip>
    <div class="row pt-4 pt-lg-4">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/household_income.svg" alt="household-income">
      </div>
    </div>
    <div class="row pt-4 row-title">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t('householdIncome.title') }}
        </label>
      </div>
    </div>
    <div class="row pt-4">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <input v-model="income" value="0-24999" id="range1" type="radio"/>
        <label class="option-label" for="range1">{{ $t('householdIncome.range1') }}</label>
      </div>
      <div class="col-6 col-lg-4 pl-0">
        <input v-model="income" value="25000-49999" id="range2" type="radio"/>
        <label class="option-label" for="range2">{{ $t('householdIncome.range2') }}</label>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <input v-model="income" value="50000-74999" id="range3" type="radio"/>
        <label class="option-label" for="range3">{{ $t('householdIncome.range3') }}</label>
      </div>
      <div class="col-6 col-lg-4 pl-0">
        <input v-model="income" value="75000-99999" id="range4" type="radio"/>
        <label class="option-label" for="range4">{{ $t('householdIncome.range4') }}</label>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <input v-model="income" value="100000-124999" id="range5" type="radio"/>
        <label class="option-label" for="range5">{{ $t('householdIncome.range5') }}</label>
      </div>
      <div class="col-6 col-lg-4 pl-0">
        <input v-model="income" value="125000-149999" id="range6" type="radio"/>
        <label class="option-label" for="range6">{{ $t('householdIncome.range6') }}</label>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <input v-model="income" value="150000-174999" id="range7" type="radio"/>
        <label class="option-label" for="range7">{{ $t('householdIncome.range7') }}</label>
      </div>
      <div class="col-6 col-lg-4 pl-0">
        <input v-model="income" value="175000-199999" id="range8" type="radio"/>
        <label class="option-label" for="range8">{{ $t('householdIncome.range8') }}</label>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <input v-model="income" value="200000-up" id="range9" type="radio"/>
        <label class="option-label" for="range9">{{ $t('householdIncome.range9') }}</label>
      </div>
    </div>
    <div class="row pb-2 row-next">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <button class="btn btn-lg text-light next" @click="next">
          {{ $t('general.next') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import BackAndSkip from '../components/BackAndSkip.vue'

export default {
  data () {
    return {
      income: ''
    }
  },
  components: {
    BackAndSkip
  },
  methods: {
    next () {
      if (this.$v.$invalid) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: this.$t('general.selectOptionError')
        })
      } else {
        const answer = {
          key: 'average_household_income',
          value: this.income
        }

        this.$store.commit('SET_DATA_SURVEY', answer)

        this.$router.push({
          name: 'thankyou'
        })
      }
    }
  },
  validations: {
    income: {
      required
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'householdincome')
  }
}
</script>

<style>
.household-income .img-question {
  width: 100%;
  height: 28vh;
}

.household-income .title {
  font-weight: 700;
  font-size: 1.3rem;
}

.household-income .option-label {
  font-size: .85rem;
}

.household-income [type="radio"]:checked, [type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}

.household-income [type="radio"]:checked + label, [type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
}

.household-income [type="radio"]:checked + label:before, [type="radio"]:not(:checked) + label:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #ddd;
  border-radius: 100%;
  background: #fff;
}

.household-income [type="radio"]:checked + label:after, [type="radio"]:not(:checked) + label:after {
  content: '';
  width: 10px;
  height: 10px;
  background: #2bb1c4;
  position: absolute;
  top: 4px;
  left: 4px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.household-income [type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}

.household-income [type="radio"]:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}

.household-income .row-next {
  padding-top: 3rem;
}

.household-income .next {
  width: 85%;
  min-height: 83px;
  background-color: #2bb1c4;
  font-weight: 300;
  border-radius: 15px;
}

@media screen and (device-aspect-ratio: 40/71) {
  .household-income .img-question {
    width: 100%;
    height: 16vh;
  }

  .household-income .title {
    font-size: 1rem;
  }

  .household-income .option-label {
    font-size: .7rem;
  }

  .household-income .next {
    min-height: 70px;
  }

  .household-income .row-next {
    padding-top: 1rem;
  }
}
</style>
